import { createApi } from '@reduxjs/toolkit/query/react'
import { baseUrl } from './axiosInstance'
import axiosBaseQuery from './axiosBaseQuery'

const IntegrationApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'IntegrationApi',
  tagTypes: ['integration'],
  endpoints: () => ({})
})

export default IntegrationApi
